import { render } from "./SandboxJobsTab.vue?vue&type=template&id=e0e4175a"
import script from "./SandboxJobsTab.vue?vue&type=script&lang=js"
export * from "./SandboxJobsTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__